export const MAX_IMAGES_COUNT = 10;
export const MIN_IMAGES_COUNT = 1;
export const MIN_RETAIL_PRICE_AMOUNT = 1;
export const ACCEPTED_FILE_TYPE = 'image/';
export const ACCEPTED_VIDEO_TYPES = ['video/mp4', 'video/quicktime'];
export const ACCEPTED_DD_FILE_TYPES = ['jpg', 'jpeg', 'png', 'gif', 'mov', 'mp4', 'pdf', 'txt'];
export const ARTWORK_IMAGE_FILE_SIZE_LIMIT = 50 * 1024 * 1024;
export const ARTWORK_VIDEO_FILE_SIZE_LIMIT = 2000 * 1024 * 1024;
export const ARE_QR_BUTTONS_ENABLED = false; // Disabled in ARCGP-383; may be enabled back when decided
